import { ENDPOINT } from '~/constants';

import { LOADING_STATE } from '../constants/loadingState';
import SupplierAlertConfig from '../models/SupplierAlertConfig';
import {
  replaceSupplierAlertConfigs,
  setSupplierAlertConfigsLoading,
} from '../redux/companiesSlice';
import store from '../redux/store';
import { promiseHandler } from '../utils/promiseHandler';

import { vestigasApi } from './kyClient';
import ToastService from './toast.service';

class CompanyService {
  async getAllSupplierAlertConfigs() {
    return vestigasApi
      .get(ENDPOINT.COMPANY.SUPPLIER_ALERT_CONFIGS.GET_ALL())
      .json()
      .then((data) => {
        return data.map((item) => {
          const supplierAlertConfig = new SupplierAlertConfig();
          supplierAlertConfig.init(item);
          return supplierAlertConfig;
        });
      })
      .catch((error) => {
        ToastService.httpError(
          ['Supplier Alert Configs konnten nicht geladen werden.'],
          error.response,
        );
        throw error;
      });
  }

  loadSupplierAlertConfigs = async () => {
    // to not load data again when they are already loading or have already been loaded
    if (
      store.getState().companies?.supplierAlertConfigsLoading !==
      LOADING_STATE.NOT_LOADED
    ) {
      return;
    }

    await this.refreshSupplierAlertConfigs();
  };

  refreshSupplierAlertConfigs = async () => {
    store.dispatch(setSupplierAlertConfigsLoading(LOADING_STATE.LOADING));

    const [supplierAlertConfigs, error] = await promiseHandler(
      this.getAllSupplierAlertConfigs(),
    );

    if (error) {
      store.dispatch(setSupplierAlertConfigsLoading(LOADING_STATE.FAILED));
      return;
    }

    store.dispatch(replaceSupplierAlertConfigs(supplierAlertConfigs));
  };

  async updateSupplierAlertConfig(companyId, body) {
    return vestigasApi
      .put(ENDPOINT.COMPANY.SUPPLIER_ALERT_CONFIGS.UPDATE(companyId), {
        json: body,
      })
      .catch((error) => {
        ToastService.httpError(
          ['Supplier Alert Config konnte nicht geändert werden.'],
          error.response,
        );
        throw error;
      });
  }

  async deleteSupplierAlertConfig(companyId) {
    return vestigasApi
      .put(ENDPOINT.COMPANY.SUPPLIER_ALERT_CONFIGS.DELETE(companyId), {
        json: {},
      })
      .catch((error) => {
        ToastService.httpError(
          ['Supplier Alert Config konnte nicht entfernt werden.'],
          error.response,
        );
        throw error;
      });
  }
}

export default new CompanyService();
